import { asyncExperienceSounds } from './asyncExperienceSounds';
import { commonSounds } from './commonSounds';
import { instantRipsSounds } from './instantRipsSounds';
import { whiteElephantSounds } from './whiteElephantSounds';

const mergeSoundDefs = (...defs) => Object.assign({}, ...defs);

export const instantRipsSoundDefs = mergeSoundDefs(commonSounds, instantRipsSounds);
export const whiteElephantSoundDefs = mergeSoundDefs(commonSounds, whiteElephantSounds);
export const asyncExperienceSoundDefs = mergeSoundDefs(commonSounds, asyncExperienceSounds);

export { commonSounds, instantRipsSounds, whiteElephantSounds, asyncExperienceSounds };
